module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-137036463-1","head":false,"anonymize":false,"respectDNT":false,"sampleRate":5,"siteSpeedSampleRate":10,"cookieDomain":"www.farajaraftingchallenge.org","exclude":[],"pageTransitionDelay":0},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
